import * as React from 'react';
const fullClone = Object.assign({}, React);
const useId = fullClone.useId;
const useEmptyId = () => '';
const useThemeKey = typeof useId === 'undefined' ? useEmptyId : useId;
export default useThemeKey;